/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function HamburguerIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 40 40" {...props}>
      <path d="M5 30H35V26.6667H5V30ZM5 21.6667H35V18.3333H5V21.6667ZM5 10V13.3333H35V10H5Z" />
    </SvgIcon>
  );
}
